export default "__VITE_ASSET__BUdDh3Q$__"